import { cn, getStatusColor, capitalizeFirst } from '../../lib/utils';

export const StatusBadge = ({ status, className }) => {
    return (
        <span 
            className={cn('status-badge', getStatusColor(status), className)}
            data-testid={`status-badge-${status}`}
        >
            {capitalizeFirst(status)}
        </span>
    );
};
